import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  makeStyles,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { ActivityToolInformation } from "../../models/Tool";
import ActivitiesUsingToolTable from "./ActivitiesUsingToolTable";

type ToolActivitiesDialogProps = {
  open: boolean;
  onClose: () => void;
  activities?: ActivityToolInformation[];
  isloading?: boolean;
  toolTitle?: string;
};

const useStyles = makeStyles({
  dialogSurface: {
    minWidth: "800px",
  },
  dialogTitle: {
    textAlign: "center",
    marginBottom: "20px",
  },
  content: {
    textAlign: "center",
  },
});

const ToolActivitiesDialog = (props: ToolActivitiesDialogProps) => {
  const { open, onClose, activities, toolTitle } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Dialog open={open} onOpenChange={(_, { open }) => !open && onClose()}>
      <DialogSurface className={classes.dialogSurface}>
        <DialogBody>
          <DialogTitle className={classes.dialogTitle}>
            {t("activitiesUsingThisTool")} {toolTitle}
          </DialogTitle>

          <DialogContent className={classes.content}>
            {activities && activities.length > 0 ? (
              <ActivitiesUsingToolTable activities={activities} />
            ) : (
              <p>{t("noActivitiesUsingThisTool")}</p>
            )}
          </DialogContent>

          <DialogActions>
            <Button onClick={onClose}>{t("close")}</Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default ToolActivitiesDialog;
